<template lang="pug">
  v-flex(:class="classObj")
    div(:title='component.label')
      GChart(:style='divStyle', type="LineChart" :data="chartData" :options="chartOptions" v-observe-visibility="visibilityChanged")
</template>

<script>
  import { GChart } from 'vue-google-charts'
  import api from '@/api/ultracare'
  import _ from 'lodash'

  export default {
    name: 'u-evolution-chart',

    components: {
      GChart
    },

    props: {
      id: {
        type: String
      },
      component: {
        type: Object
      },
      values: {
        type: Object
      },
      print: {
        type: Boolean
      },
      value: {
      },
      height: {
      },
      width: {
      }
    },

    computed: {
      divStyle () {
        let height = '450px'
        let width = '100%'

        if (this.print) {
          switch (this.component.printStyle) {
            case 'xs1':
              height = '100px'
              width = '50px'
              break
            case 'xs2':
              height = '100px'
              width = '100px'
              break
            case 'xs3':
              height = '200px'
              width = '150px'
              break
            case 'xs4':
              height = '300px'
              width = '300px'
              break
            case 'xs5':
              height = '250px'
              width = '250px'
              break
            case 'xs6':
              height = '250px'
              width = '500px'
              break
            case 'xs7':
              height = '300px'
              width = '550px'
              break
            case 'xs8':
              height = '300px'
              width = '600px'
              break
            case 'xs9':
              height = '300px'
              width = '700px'
              break
            case 'xs10':
              height = '350px'
              width = '800px'
              break
            case 'xs11':
              height = '350px'
              width = '950px'
              break
            case 'xs12':
              width = '1140px'
              break
          }
        }

        return {
          'height': this.height || this.component.height || height,
          'width': this.width || this.component.width || width,
          display: 'inline-block'
        }
      }
    },

    watch: {
      value: {
        handler: function (val) {
          this.updateChart(val)
        }
      }
    },

    data () {
      return {
        // Array will be automatically processed with visualization.arrayToDataTable function
        chartData: null,
        chartDataFetus: null,
        chartDataBase: null,
        authorRef: null,
        chartOptions: {
          title: null,
          subtitle: null,
          axisTitlesPosition: 'out',
          curveType: 'function',
          colors: ['#e98e7a', '#b5bcc7', '#e98e7a', '#15A0C8', '#981b48', '#6fa348', '#ec8a33', '#909895'],
          series: {
            0: { visibleInLegend: false },
            1: { visibleInLegend: false },
            2: { visibleInLegend: false },
            3: { pointShape: 'circle', pointSize: 12, lineWidth: 0 },
            4: { pointShape: 'square', pointSize: 12, lineWidth: 0 },
            5: { pointShape: 'diamond', pointSize: 12, lineWidth: 0 },
            6: { pointShape: 'polygon', pointSize: 12, lineWidth: 0 }
          },
          backgroundColor: {
            stroke: '#000000',
            strokeWidth: 1
          },
          chartArea: {
            width: '75%',
            height: '70%'
          },
          legend: { position: 'bottom' },
          hAxis: { title: this.component.xLabel || 'Semanas' },
          vAxis: { title: this.component.suffix || 'mm', viewWindowMode: 'maximized' }
        },
        chartMin: -1,
        chartMax: 100000
      }
    },

    mounted () {
      if (this.component.suffix) {
        this.chartOptions.vAxis.title = this.component.suffix
      }
      if (!this.chartDataBase) {
        this.refreshApiData()
      }
    },

    methods: {
      refreshApiData () {
        api.getChartPoints(this.component.apiPath, this.authorRef, this.component.suffix || 'mm', this.component.serieLabels)
          .then(data => {
            this.chartDataBase = data
            this.updateChart(this.value)
          })
          .catch(err => {
            console.error(err)
          })
        if (this.component.serieLabels) {
          const series = {}
          const seriesLength = this.component.serieLabels.length
          for (let i = 0; i < seriesLength - 1; i++) {
            series[i] = { visibleInLegend: false }
          }
          series[seriesLength - 1] = { pointShape: 'circle', pointSize: 12, lineWidth: 0 }
          series[seriesLength] = { pointShape: 'square', pointSize: 12, lineWidth: 0 }
          series[seriesLength + 1] = { pointShape: 'diamond', pointSize: 12, lineWidth: 0 }
          series[seriesLength + 2] = { pointShape: 'polygon', pointSize: 12, lineWidth: 0 }
          this.chartOptions.series = series
        }
        if (this.component.serieColors) {
          this.chartOptions.colors = this.component.serieColors.concat(['#15A0C8', '#981b48', '#6fa348', '#ec8a33', '#909895'])
        }
      },
      refreshChart () {
        if (this.chartDataBase) {
          this.chartMin = 100000
          this.chartMax = -1
          let dataChart = _.cloneDeep(this.chartDataBase)
          if (this.chartDataFetus) {
            // Ajusta a unidade de medida
            let mult = 1
            if (this.component.suffix === 'cm') {
              mult = 0.1
            }

            let rangeMin = this.chartMin
            let rangeMax = this.chartMax
            for (let key in this.chartDataFetus) {
              let points = this.chartDataFetus[key]
              let headerList = dataChart[0]
              headerList.push(key)
              for (let i = 1; i < dataChart.length; i++) {
                dataChart[i].push(null)
              }
              for (let i = 0; i < points.length; i++) {
                let point = points[i]
                let week = point[0]
                if (week < rangeMin) rangeMin = week
                if (week > rangeMax) rangeMax = week

                let itemRow

                // Graficos que não utilizam semanas
                if (this.component.xWeeks === false) {
                  itemRow = [{ v: point[0], f: `${point[0]} ${this.component.xLabel}` }]
                } else {
                  itemRow = [{ v: point[0], f: this.$options.filters.weeksAndDays(point[0] * 7, false) }]
                }
                const val = point[1] * mult
                itemRow = itemRow.concat(new Array(headerList.length - 2).fill(null)).concat({ v: val, f: `${this.$options.filters.numberLocale(val, 3)} ${this.component.suffix || 'mm'}` })
                dataChart.push(itemRow)
              }
            }

            let offset = this.component.offset || 3
            this.chartMin = rangeMin - offset
            this.chartMax = rangeMax + offset
          }

          const filter = () => {
            this.chartData = dataChart.filter(item => {
              let value = typeof item[0] === 'object' ? item[0].v : item[0]
              return typeof value === 'string' || (value >= this.chartMin && value <= this.chartMax)
            })
          }

          filter()
          if (this.chartData.length < 3) {
            this.chartMin = -1
            this.chartMax = 100000
            filter()
          }
        }
      },

      updateChart (payload) {
        if (payload) {
          if (payload.author) {
            if (payload.author !== this.authorRef) {
              this.authorRef = payload.author
              this.refreshApiData()
            }
            this.chartOptions.title = `${this.t(`${this.id}`, this.component.label)} (${this.$filters.capitalize(payload.author)}), ${this.component.article}`
            this.chartOptions.subtitle = `${this.t(`${this.id}`, this.component.label)} (${this.$filters.capitalize(payload.author)}), ${this.component.article}`
          }
          let data = []
          const items = payload.result
          if (items) {
            for (let i = 0; i < items.length; i++) {
              let item = items[i]
              data.push([`${this.component.pointLabel}-${item.id}`, item.week, item.value])
            }
          }
          if (data && (!this.chartDataFetus || data.toString() !== this.chartDataFetus.toString())) {
            this.chartDataFetus = data.reduce((acum, item) => {
              if (!acum[item[0]]) acum[item[0]] = []
              acum[item[0]].push(item.slice(1, 3))
              return acum
            }, {})
            this.refreshChart()
          }
        }
      },

      visibilityChanged (isVisible) {
        if (isVisible) {
          setTimeout(
              () => {
                window.dispatchEvent(new Event('resize'))
              },
                    500
          )
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/EvolutionChart.vue